module.exports = __webpack_public_path__ + "media/assets/images/flags/zm-5ac683c415ca731a96a3ed8ecd76ac1d.svg";